'use client';

import { useRouter } from 'next/navigation';
import React from 'react';
import { ConfirmModal } from '@/app/components/ConfirmModal';
import { DASHBOARD_PATH } from '@/consts/paths';

interface AccessRestrictedModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AccessRestrictedModal: React.FC<AccessRestrictedModalProps> = ({ isOpen, onClose }) => {
  const router = useRouter();

  const handleClose = () => {
    onClose();
    router.push(DASHBOARD_PATH);
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={handleClose}
      onConfirm={handleClose}
      title="Access restricted"
      description="You don't have permission to view this content. Please contact your administrator or try logging in with the appropriate account."
      confirmLabel="Go to Dashboard"
      confirmIntent="primary"
      hideCancel
    />
  );
};
